export default "__VITE_ASSET__BlsnA3J5__"